import {FC} from 'react'
import {SnackbarProvider} from 'notistack'
import {renderPanelContent} from '../components'
import {Panel, PanelGroup} from 'react-resizable-panels'
import { useLavanderia } from '../../../../../hooks/useLavanderia'
import ContainerWrapper from '../../../../central/pages/componentes/Container'

const DeliveryClothesWrapper: FC = () => {
    const {currentTabItem} = useLavanderia()
  return (
    <ContainerWrapper>
      <PanelGroup autoSaveId='example' direction='vertical'>
        <Panel
          collapsible={true}
          order={1}
          key={`panel-hoteleria-header-${currentTabItem.title}`}
          id={`panel-hoteleria-header-${currentTabItem.title}`}
          className={'panel__box'}
        >
          {renderPanelContent(currentTabItem.content.headerPanel)}
        </Panel>
        {currentTabItem.showPanel && (
          <>
            <Panel
              className={'panel__box'}
              collapsible={true}
              defaultSize={50}
              order={2}
              key={`panel-hoteleria-detail-${currentTabItem.title}`}
              id={`panel-hoteleria-detail-${currentTabItem.title}`}
            >
              {renderPanelContent(currentTabItem.content.detailPanel)}
            </Panel>
          </>
        )}
      </PanelGroup>
      <SnackbarProvider />
    </ContainerWrapper>
  )
}

export default DeliveryClothesWrapper
